import { render, staticRenderFns } from "./AutomaticRoundTimeLeft.vue?vue&type=template&id=e044d8b6&scoped=true&"
import script from "./AutomaticRoundTimeLeft.vue?vue&type=script&lang=js&"
export * from "./AutomaticRoundTimeLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e044d8b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
